import React, { useState, useMemo } from 'react';
import moment from 'moment';

import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { timeRange } from './spendFilterDefault';
import { useFilterData } from './hooks';
import { PUBG_GAME_CODE_LIST } from '../../_config/constant';
import { FORM_MAP } from '../../utils/_config/constant';
import { useSelector } from 'umi';
import { filterValueType } from '../../components/NewFilter/_type';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const firstWordUpper = (str: string) => {
  if (!str) return str;
  const firstLetter = str.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = str.slice(1);
  return firstLetterCap + remainingLetters === 'Date' ? 'Day' : firstLetterCap + remainingLetters;
};

// 筛选器路径
const FILTER_PATH = 'ua/spend';

const SpendFilterNew = (props: any) => {
  const { filterConfirm, filterReset, buttonLogConfig, setFilterLoading, filterInit, gameCode, openSticky = false } = props;
  const [filterValue, setFilterValue] = useState<any>(null); // 筛选器值，使用state确保值始终最新
  const { loading, selector } = useFilterData();
  const isPUBGM = PUBG_GAME_CODE_LIST.includes(gameCode);
  // 临时处理：和晓涵核对后，ua 页面，默认进入页面，demo游戏先传固定时间范围2023.01.30-2023.02.06
  const isDemo = gameCode === 'demo' || gameCode === 'pc_demo';

  const {seasonInfo} = useSelector((state: any) =>
    // 初始可能为undefied,在此加兜底
    ({
      seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || {date: [],week: [],month: []},
    })
  );

  // 设置inputList
  const inputList = useMemo(() => {
    const demoTimeDefault = [moment('2023-01-30'),moment('2023-02-06')];
    return [
      {
        type: 'rangeDate',
        key: 'rangeTime',
        default: {
          type: 'date',
          value: isDemo ? demoTimeDefault: [moment(timeRange(isPUBGM).Day[0]), moment(timeRange(isPUBGM).Day[1])],
        },
        componentDefault: {
          date: isDemo ? demoTimeDefault: [moment(timeRange(isPUBGM).Day[0]), moment(timeRange(isPUBGM).Day[1])],
          week: isDemo ? demoTimeDefault: [moment(timeRange(isPUBGM).Week[0]), moment(timeRange(isPUBGM).Week[1])],
          month: isDemo ? demoTimeDefault: [moment(timeRange(isPUBGM).Month[0]), moment(timeRange(isPUBGM).Month[1])],
        },
        typeList: ['date', 'week', 'month'],
        extraShortcut: seasonInfo
      },
      {
        key: 'region',
        default: {
          region_type: 'market',
          markets: ["255"],
          regions: []
        },
      },
      {
        key: 'system',
        default: ["255"],
      },
      {
        key: 'networkType',
        default: ["255"],
      },
      {
        key: 'mediaChannel',
        default: ["255"],
      }
    ];
  }, [isDemo, isPUBGM, seasonInfo]);

  const handleConfirm = (value: any) => {
    setFilterValue(value);
    filterConfirm?.({
      filterValue: {
        ...value,
        rangeTime: [
          value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
          value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
        ],
      },
      timeType: firstWordUpper(value?.rangeTime?.type),
      [FORM_MAP.RANGE_TIME_DIFF]: false,
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, {
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
    });
  };

  const handleReset = (value: any) => {
    setFilterValue(value);
    filterReset?.({
      filterValue: {
        ...value,
        rangeTime: [
          value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
          value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
        ],
      },
      timeType: firstWordUpper(value?.rangeTime?.type),
      [FORM_MAP.RANGE_TIME_DIFF]: !isDemo,
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, {
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
    }, true);
  };

  const handleInit = (value: any, inputList: any, isHaveExtendFIlter: any) => {
    setFilterValue(value);
    filterInit?.({
      filterValue: {
        ...value,
        rangeTime: [
          value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
          value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
        ],
      },
      timeType: firstWordUpper(value?.rangeTime?.type),
      [FORM_MAP.RANGE_TIME_DIFF]: isDemo ? false : !isHaveExtendFIlter,
    });
    setFilterLoading(false);
  };

  const handleChange = (key: string, value: any, formVal: filterValueType) => {
    setFilterValue({...formVal, [key]: value});
  };


  return (
    <div className='filter-select'>
      <Filter
        openSticky={openSticky}
        path={FILTER_PATH}
        isHaveFilterSave={false}
        loading={loading}
        useOutInput={true}
        outSelector={selector}
        value={filterValue}
        latestDateType={''}
        outLatestDate={selector?.latestDate}
        inputList={inputList}
        onInit={handleInit}
        onConfirm={handleConfirm}
        onReset={handleReset}
        onChange={handleChange}
      />
    </div>
  );
};

export default SpendFilterNew;
